export { default as TextColumnComponent } from './text-column-component';
